<template>
  <v-layout row wrap>
    <v-flex xs6>
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="formattedDate"
            :label="label"
            prepend-icon="event"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="dateValue"
          no-title
          @input="menu = false"
          :locale="$i18n.locale"
          first-day-of-week="1"
          ref="picker"
        ></v-date-picker>
      </v-menu>
    </v-flex>
    <v-flex xs6>
      <v-menu
        v-model="menu2"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="formattedTime"
            readonly
            v-on="on"
            :append-icon="value != null && !required?'cancel':undefined"
            @click:append="erase"
          ></v-text-field>
        </template>
        <v-time-picker
          v-model="timeValue"
          @click:minute="menu2 = false"
          :locale="$i18n.locale"
          format="24hr"
          ref="picker2"
        ></v-time-picker>
      </v-menu>
    </v-flex>
  </v-layout>
</template>

<script>
import {
  VCard,
  VTooltip,
  VForm,
  VTextField,
  VCardActions,
  VCardText,
  VSelect,
  VDatePicker,
  VTimePicker,
  VMenu,
  VIcon,
  VTextarea,
  VDataTable,
  VAutocomplete,
  VCheckbox,
  VAlert,
  VDialog
} from "vuetify/lib";
import fccapi from "../fccapi.js";

export default {
  name: "FCCDateTime",
  data: () => ({
    menu: false,
    menu2: false,
    value: null,
    dateValue: null,
    timeValue: null
  }),
  computed: {
    rules: function() {
      return {
        required: value => !!value || this.$t("registration.required")
      };
    },
    formattedDate: function() {
      if (!this.dateValue) return "";
      var re = new RegExp(/(\d\d\d\d)-(\d\d?)-(\d\d?)/);
      var r = this.dateValue.match(re);
      return parseInt(r[3]) + "." + parseInt(r[2]) + "." + parseInt(r[1]);
    },
    formattedTime: function() {
      if (!this.timeValue) return "";
      var re = new RegExp(/(\d\d?):(\d\d?)(:\d\d)?/);
      var r = this.timeValue.match(re);
      return parseInt(r[1]) + ":" + r[2];
    },
    originalValue: function() {
      if (this.source == null) return null;
      return this.source[this.propertyName];
    }
  },
  props: {
    source: Object,
    propertyName: String,
    label: String,
    required: Boolean
  },
  components: {
    VTooltip,
    VTextField,
    VCardActions,
    VCardText,
    VSelect,
    VIcon,
    VDatePicker,
    VTimePicker,
    VMenu,
    VTextarea
  },
  watch: {
    value(val) {
      if (this.source == null) return;
      this.source[this.propertyName] = val;
      if(val != null){
        var re = new RegExp(/(\d\d\d\d)-(\d\d?)-(\d\d?)T(\d\d?):(\d\d?):(\d\d?)?/);
        var r = val.match(re);
        if(r == null) return null;
        this.timeValue = r[4] + ":" + r[5];
        this.dateValue = r[1] + "-" + r[2] + "-" + r[3];
      }
      else{
          this.timeValue = null;
          this.dateValue = null;
      }
    },
    timeValue(val) {
        if(val == null) return;
        this.value = this.dateValue+"T"+this.timeValue+":00";
    },
    dateValue(val) {
        if(val == null) return;
        var v = this.dateValue+"T";
        if(this.timeValue == null) {
            v += "00:00:00";
        }
        else v += this.timeValue;
        this.value = v;
    },
    originalValue(val) {
      this.value = val;
    }
  },
  methods: {
    erase: function() {
      this.value = null;
    }
  },
  mounted: function(){
    this.value = this.originalValue;
  }
};
</script>